/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const funnel = (
	<SVG viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
		<Path d="M10 17.5H14V16H10V17.5ZM6 6V7.5H18V6H6ZM8 12.5H16V11H8V12.5Z" />
	</SVG>
);

export default funnel;
